/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { closeModal, switchModal, speak } from '../../actions';
import X from '../../assets/login/x.svg';

const Onboarding3 = (props) => {
  return (
    <div className="modal onboarding-background onboarding-3">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className="onboarding-header">
        Check this out!
      </h2>
      <div className="onboarding-main-container">
        <div className="onboarding-body">
          <div>
            <div className="onboarding-circle">3</div>
          </div>
          <div>
            <h4 className={`${props.speechEnabled && 'bolded'} color`} onClick={props.speak}>Accessing your dashboard</h4>
            <div className="onboarding-text-container">
              <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'} color`}>
                Your results will be available to you through your dashboard, so that you will have easy and ongoing access to all of your information and tools. Once you login, your dashboard will be your landing page each time you begin My Brain Explained.
              </p>
            </div>
          </div>
        </div>
        <div className="onboarding-nav">
          <p onClick={() => props.switchModal('Onboarding2')} className="skip">Back</p>
          <p onClick={() => props.switchModal('Onboarding4')} className="skip">Next</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal, speak })(Onboarding3);
